import React from "react";
import css from './footerHelpFloor2.module.scss'
import classNames from "classnames";
import {observer} from "mobx-react";
import Router from "router/router";
import {useHistory} from "react-router-dom";

class Data {
    history = undefined

    list = [
        {
            title: "首页",
            onClick: () => {
                const location = {
                    pathname: Router.Home.path
                }
                this.history.push(location)
            },
            location: Router.Home.path,
        },
        {
            title: "隐私保护",
            onClick: () => {
                const location = {
                    pathname: Router.Help.path,
                    search: `categoryId=1&articleId=19`,
                }
                this.history.push(location)
            },
            location: {
                pathname: Router.Help.path,
                search: `categoryId=1&articleId=19`,
            },
        },
        {
            title: "联系我们",
            onClick: () => {
                const location = {
                    pathname: `${Router.News.realPath}/33`,
                    search: `menuType=1&categoryId=1`
                }
                this.history.push(location)
            },
            location: {
                pathname: `${Router.News.realPath}/33`,
                search: `menuType=1&categoryId=1`
            },
        },
        {
            title: "免责条款",
            onClick: () => {
                const location = {
                    pathname: Router.Help.path,
                    search: `categoryId=1&articleId=18`,
                }
                this.history.push(location)
            },
            location: {
                pathname: Router.Help.path,
                search: `categoryId=1&articleId=18`,
            },
        },
        {
            title: "公司简介",
            onClick: () => {
                const location = {
                    pathname: Router.Introduce.path
                }
                this.history.push(location)
            },
            location: Router.Introduce.path,
        },
        {
            title: "招商入驻",
            onClick: () => {
                const location = {
                    pathname: Router.Merchant.path,
                }
                this.history.push(location)
            },
            location: {
                pathname: Router.Merchant.path,
            },
        },
        {
            title: "平台总则",
            onClick: () => {
                const location = {
                    pathname: Router.Help.path,
                    search: `categoryId=1&articleId=17`,
                }
                this.history.push(location)
            },
            location: {
                pathname: Router.Help.path,
                search: `categoryId=1&articleId=17`,
            },
        },
    ]

    constructor({history}) {
        this.history = history;
    }
}

const Index = ({className}) => {

    const history = useHistory()

    const data = new Data({history})

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.itemList}>
                    {
                        data.list.map((item, i) => {
                            const {title, onClick} = item
                            return (
                                <div key={i} className={css.item} onClick={onClick}>
                                    <span>{title}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default observer(Index)